import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import UserSymbol from '../../../User/_partials/UserSymbol';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './SymbolLegendItem.scss';
const SymbolLegendItem = ({ className, title, description, userSymbol, moreUrl })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(UserSymbol, {
        "aria-hidden": "true",
        userSymbol: userSymbol,
        className: classnames(s['symbol'], s[`symbol-${userSymbol}`])
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, t(title)), /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, t(description)), moreUrl && /*#__PURE__*/ React.createElement(BiLink, {
        href: moreUrl,
        className: s['more-link'],
        target: "_blank",
        rel: "noopener noreferrer",
        biData: BiData({
            evid: 112,
            link_name: userSymbol,
            link_url: moreUrl
        })
    }, t('userSymbolsPopup.v2.learnMore'))));
};
SymbolLegendItem.displayName = 'SymbolLegendItem';
export default SymbolLegendItem;

//# sourceMappingURL=SymbolLegendItem.js.map